import Reactions from './Reactions.component';

export default Reactions;
